 <template>

   <!--试听结束弹窗新版（有优惠券）-->
   <div class="alert-box listen-end-box" :class="cdCls">
     <p class="mask" @click="closeAlertListenEnd(false)"></p>
     <div class="alert-con">
       <img class="icon-close" src="../assets/icon-close.png" @click="closeAlertListenEnd(false)" />
       <div class="alert-info border-box">
         <div class="video-info clearfix">
           <p class="video-info-img border-box">
             <img class="img" :src="bag.guideheadimg2?bag.guideheadimg2:bag.guideheadimg" />
           </p>
           <div class="video-title">
             <p class="video-info-title hide" v-if="couponid == ''">{{bag.name}}</p>
             <p class="video-info-title hide" v-else>我来解说{{bag.shopname}}</p>
             <p class="video-info-sub hide">（共包含{{bag.sees}}个景点解说语音）</p>
           </div>
           <p style="text-align:center;color:red;font-size:.28rem;margin-top:.24rem;margin-bottom:.32rem;" v-if="couponid == ''">{{spotbuy==1?'收听结束':'试听结束'}} <br/> 购买即可收听全部内容</p>
         </div>

         <template v-if="couponid != ''">
           <div class="pay-li border-box" style="margin-top:.4rem;">
             <span class="fl">订单金额</span>
             <span class="fr">{{bag.price}}元</span>
           </div>
           <div class="pay-li border-box">
             <span class="fl">优惠抵扣</span>
             <span class="fr">{{extral.money}}元<img class="pay-right" src="../assets/back.png" /></span>
           </div>
         </template>

         <button class="btn-pay" @click="payOrder" v-if="spotbuy==1">立即购买</button>
         <button class="btn-pay" @click="payOrder" v-else>支付{{extral.usermoney}}元</button>
       </div>
     </div>
   </div>

</template>

 <script>
   import {setStore, getStore, removeStore} from '@/config/mUtils'
   import {creatOrder, pushOrder} from '@/utils/wechat'
   import D from '@/wc-messagebox'
   import Vue from 'vue'
   Vue.use(D)

   export default {
     data(){
       return{

       }
     },
     created(){
       this.appKey = this.$route.query.appKey || "";
       if(this.appKey){
         this.appKey = encodeURIComponent(this.appKey)
       }
     },
     props: ['bag','couponid','extral','bagtype','shopid','spotbuy'],
     computed: {
       cdCls() {
         var cla
         if(this.bagtype == 'sm'){
           cla = 'sm'
         }
         return cla
       }
     },
     methods: {
       //关闭试听播放结束引导购买弹窗
       closeAlertListenEnd(isbuy){
         if(isbuy){
           this.$emit('close',{isbuy: true, bag: {}});
         }else {
           this.$emit('close',{isbuy: false, bag: {}});
         }

       },

       //创建订单并支付
       payOrder(){
         MtaH5.clickStat('xiangqingyeshit',{'viewdetailbuy':'true'});//景区景点点击试听》1弹窗购买》支付
         MtaH5.clickStat('jingqujingdiana-4',{'3buy':'true'});//景区景点进入专辑详情》试听》1弹窗购买》支付
         let self = this;
         let path = this.$route.path;
         setStore("couponid", {"couponid": ""});
         (!self.bag.shopid) && (self.bag.shopid = self.shopid ||"");
         if(self.spotbuy==1){
           self.$router.push({
             path: `/pay-py?${'pid='+self.bag.id+'&cid='+self.couponid+'&shopid='+self.bag.shopid+'&appKey='+this.appKey}`
           });
         }else if(self.bagtype && self.bagtype == 'lz'){
           self.$router.push({
             path: `/pay?${'pid='+self.bag.id+'&cid='+self.couponid+'&shopid='+self.bag.shopid+'&bagtype=lz'+'&appKey='+this.appKey}`
           });
         }else if(self.bagtype && self.bagtype == 'sm'){
           self.$router.push({
             path: `/pay?${'pid='+self.bag.id+'&cid='+self.couponid+'&shopid='+self.bag.shopid+'&bagtype=sm'+'&appKey='+this.appKey}`
           });
         }else{
           self.$router.push({
             path: `/pay?${'pid='+self.bag.id+'&cid='+self.couponid+'&shopid='+self.bag.shopid+'&appKey='+this.appKey}`
           });
         }


       },

     },
   }
 </script>

 <style scoped>

   @import '../style/alert';

   .listen-end-box.sm .alert-con{ background: #fff url(../assets/sm-shade.png) repeat; }
   .listen-end-box.sm .btn-pay{ background: #796042; }
 </style>



// WEBPACK FOOTER //
// src/components/AlertListenEnd.vue